import React from 'react'

import PrivacyEn from './en'
import PrivacyFr from './fr'

function Privacy({ locale }) {
  if (locale === 'fr-FR') return <PrivacyFr />
  return <PrivacyEn />
}

export default Privacy
